var render = function render(){var _vm=this,_c=_vm._self._c;return _c('facial-instruction',{attrs:{"id":"facial-instruction","strategy":_vm.strategy,"personalization":_vm.personalInfoConfig.personalData.personalization.instructions},on:{"click:continue":function($event){_vm.strategy === 'facialRecognition'
      ? _vm.$router.push({ name: 'face-recognition' })
      : _vm.$router.push({ name: 'take-picture' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }